module.exports = __webpack_public_path__ + "img/home.f215cd2.png";